import * as React from "react";
import PropTypes from "prop-types";
import {withPrefix } from "gatsby";
import "../styles/form.css";
import { Helmet } from "react-helmet";
import HubspotForm from "react-hubspot-form";

 
const NLForm = ({ siteTitle }) => (
  
    <>
    <Helmet>
     <meta name="viewport" content="width=device-width, initial-scale=1"/> 
    </Helmet> 
    		<div className="form-section">
          <HubspotForm
            region="na1"
            portalId="2778625"
            formId="7cc6c2a7-412d-4412-82db-e781af01cfcf"
            loading={<div></div>}
          />
        </div>
    </>
  )

NLForm.propTypes = {
  siteTitle: PropTypes.string,
}

NLForm.defaultProps = {
  siteTitle: ``,
}

export default NLForm

